exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n  position: absolute;\n  overflow: hidden;\n  z-index: -1;\n  width: 100%;\n  height: 100%; }\n\n.painter {\n  position: absolute;\n  height: 100%;\n  right: 0; }\n  @media (max-width: 1400px) {\n    .painter {\n      display: none; } }\n\n.paintLeft {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: calc(100% - 1000px);\n  height: 100%;\n  background: #005073; }\n  @media (max-width: 1400px) {\n    .paintLeft {\n      width: 100%; } }\n\n.collectionsContainer {\n  padding: 1rem; }\n\n.controls {\n  text-align: center;\n  font-family: 'Dancing Script', cursive;\n  color: white;\n  height: 100%; }\n  .controls h1 {\n    margin: 0;\n    color: white;\n    text-shadow: 0 0.2rem rgba(0, 0, 0, 0.4); }\n\nh2 {\n  margin-top: 1rem; }\n\n[appButton], [appButtonPrimary] {\n  width: 200px;\n  margin: 4rem auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Thomas/Projekte/palettes/src/app/home/containers/home/home.component.scss
// module id = ../../../../../src/app/home/containers/home/home.component.scss
// module chunks = main